export enum DateTimeTemplate {
    FULL_TIME = 'LTS',
    FULL_DATE = 'LL',
    ONLY_DATE = 'L',
    ONLY_TIME = 'LT',
    ONLY_TIME_TODAY = 'HH:mm',
    ONLY_YEAR = 'YYYY',
    ONLY_MONTH = 'MMM YYYY',
    ONLY_WEEK = 'W GGGG',
    SHORT_WEEKDAY = 'ddd',
    SHORT_FULL_DATE = 'll',
}

export enum DateTimeFormat {
    DATE_AND_TIME = 'DATE_AND_TIME',
    FULL_DATE_AND_TIME = 'FULL_DATE_AND_TIME',
    FULL_DATE_AND_TIME_NUMERIC = 'FULL_DATE_AND_TIME_NUMERIC',
    ONLY_DATE = 'ONLY_DATE',
    ONLY_TIME = 'ONLY_TIME',
    ONLY_TIME_TODAY = 'ONLY_TIME_TODAY',
    ONLY_YEAR = 'ONLY_YEAR',
    ONLY_MONTH = 'ONLY_MONTH',
    ONLY_WEEK = 'ONLY_WEEK',
    ONLY_DAY = 'ONLY_DAY',
    ONLY_HOUR = 'ONLY_HOUR',
    SHORT_FULL_DATE = 'SHORT_FULL_DATE',
}

export enum LanguageLocaleMapper {
    'en' = 'en-GB',
    'da' = 'da',
}

export enum LanguageDateTimeFormatSeparatorOverride {
    'da' = '-',
}
